export default __webpack_public_path__ + "static/media/Mascota Segura.6c6dd7db.svg";